import React from "react";
import { ErrorBoundary } from "components/Shared";
import { translate } from 'lib'
const Announce = ({ activity }: { activity: tcpinpoint.ActivityItem }) => <ErrorBoundary>
    <span className="activity-item-announcement-name">{translate(activity.attributes.item.name)}</span>
    {activity.attributes.item.content}
</ErrorBoundary>

export default Announce;